import React, { useContext } from 'react';
import { IoSettingsOutline } from 'react-icons/io5';
import { BiLinkExternal } from 'react-icons/bi';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { MdDeleteOutline } from 'react-icons/md';

import * as S from './styles';
import { UseTranslationProps } from 'types/UseTranslationProps';
import DynamicPageContext from 'context/DynamicPage';
import GeneralConfigContext from 'context/GeneralConfigContext';
import SystemNotifyContext from 'context/SystemNotifyContext';
import LoadGeneralContext from 'context/LoadGeneralContext';
import { listRoutes } from 'router/listRoutes';
import QuestionBox from 'components/QuestionBox';
import { deletePage } from './reqs';
import { getPages } from 'pages/DynamicPage/reqs';

interface ListDynamicPagesProps {
	page: number;
	setTotalPage: React.Dispatch<React.SetStateAction<number>>;
	setPage: React.Dispatch<React.SetStateAction<number>>;
}

export default function ListDynamicPages({
	setPage,
	setTotalPage,
	page
}: ListDynamicPagesProps) {
	const { t }: UseTranslationProps = useTranslation();
	const {
		dynamicPagesList,
		setIsFormOpen,
		setDynamicPageSelected,
		setDynamicPagesList
	} = useContext(DynamicPageContext);
	const { generalConfigs } = useContext(GeneralConfigContext);
	const { handleNotify } = useContext(SystemNotifyContext);
	const { setMessage, setIsOpenLoad } = useContext(LoadGeneralContext);

	function canShowEditBtn(slug: string) {
		if (generalConfigs === null || generalConfigs?.non_editable_pages === null)
			return true;

		return !generalConfigs.non_editable_pages.includes(slug);
	}

	async function handleDeletePage(id: string) {
		setIsOpenLoad(true);
		setMessage('Deletando página');

		const { isSuccess } = await deletePage(id, handleNotify);

		if (isSuccess) {
			await getPages(
				page,
				setTotalPage,
				setPage,
				setDynamicPagesList,
				handleNotify
			);
		}

		setIsOpenLoad(false);
	}

	return (
		<S.container>
			{dynamicPagesList.length > 0 ? (
				<S.listPage>
					{dynamicPagesList.map((item) => (
						<S.page key={item.id}>
							<p>{item.name}</p>
							<S.btns>
								<Link
									to={`${listRoutes.dynamicPages}/${item.slug}`}
									onClick={() => {
										setDynamicPageSelected(item);
									}}
								>
									<BiLinkExternal />
								</Link>

								{canShowEditBtn(item.slug) ? (
									<IoSettingsOutline
										onClick={() => {
											setDynamicPageSelected(item);
											setIsFormOpen(true);
										}}
									/>
								) : (
									<QuestionBox
										width={2.2}
										text="Está é uma página não editável. Para editar a mesma mude a configuração no painel administrativo"
									/>
								)}

								{canShowEditBtn(item.slug) && (
									<MdDeleteOutline onClick={() => handleDeletePage(item.id)} />
								)}
							</S.btns>
						</S.page>
					))}
				</S.listPage>
			) : (
				<S.noData>
					<p>{t('dynamicPage.noPage')}</p>
				</S.noData>
			)}
		</S.container>
	);
}
